import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CallingScriptModal = ({
  showCallingScript,
  handleClose,
  customer_name,
  product_name,
  customer_mobile_number,
  notice_date,
  email_id,
  loan_account_no,
  pos,
  pre_approved_settlement_amount,
  collection_manager_name,
  collection_manager_mobile_number,
  client_name,
  client_id,
  vehicle_type,
  vehicle_number,
  conciliation_status,
}) => {
  const [language, setLanguage] = useState(client_id === 10 || client_id === 55 ? 'hindi' : 'english');

  // Helper to format date like "4th December 2025"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const hasSettlementAmount = Number(pre_approved_settlement_amount) > 0;

  return (
    <Modal show={showCallingScript} onHide={handleClose} centered dialogClassName="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notice Information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {client_id === 10 ? (
          // Client 10 Script (Werize / TVS Credit)
          language === 'hindi' ? (
            <div>
              <p className='mt-3'>
                Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
              </p>
              <p>
                Ye call aapke TVS Credit ke loan account se related hai, jo <strong>{vehicle_type}</strong> – Vehicle No. <strong>{vehicle_number}</strong> par liya gaya tha.
              </p>
              <p>
                Payment default ke chalte aapka vehicle repossess aur sell kiya ja chuka hai. Sale ke baad bhi poora loan recover nahi ho paaya.
              </p>
              <p>
                Is case mein <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID / address par legal notice bheja ja chuka hai.
              </p>
              <p>
                Sale adjustment ke baad, aap par <strong>₹{pos}</strong> abhi bhi legally payable hai, aur isi recovery ke liye TVS Credit ne ye case hume legal action ke liye assign kiya hai.
              </p>
              <p>
                Lekin legal action se pehle, aapko ek final opportunity di ja rahi hai jisme <strong>₹{pre_approved_settlement_amount || 0}</strong> ke waiver amount par is matter ko close kiya ja sakta hai.
                Isse aapka CIBIL record improve hoga aur aage chal kar loan eligibility bhi restore ho sakti hai, subject to timely payment.
              </p>
              <p>
                Agar aap waiver ke liye agree karte hain, to isi call par confirm karein.
                Agar aap cooperate nahi karte, to legal action as per law without any further notice initiate kiya jayega.
              </p>
            </div>
          ) : (
            <div>
              <p className='mt-3'>
                Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
              </p>
              <p>
                This call is in relation to your TVS Credit loan account for <strong>{vehicle_type}</strong> – Vehicle No. <strong>{vehicle_number}</strong>.
              </p>
              <p>
                Due to continuous payment default, the vehicle was repossessed and sold as per due process. However, even after adjusting the sale proceeds, the entire loan outstanding could not be recovered.
              </p>
              <p>
                A legal notice was already issued on <strong>{formatDate(notice_date)}</strong> to your registered email ID / address.
              </p>
              <p>
                After adjustment of sale proceeds, a balance amount of <strong>₹{pos}</strong> remains legally payable. For recovery of this balance, TVS Credit has assigned this case to us for initiating legal action.
              </p>
              <p>
                However, before proceeding legally, you are being given a final opportunity to resolve the matter through a waiver option, wherein the account can be closed against a payment of <strong>₹{pre_approved_settlement_amount || 0}</strong>, subject to immediate confirmation and timely payment.
              </p>
              <p>
                Closure under this waiver will also help improve your CIBIL record and may enable you to avail loans in the future, subject to credit policies.
              </p>
              <p>
                If you are agreeable to this waiver, please confirm during this call.
                If not, we will proceed with legal action as per law, without any further notice.
              </p>
            </div>
          )
        ) : client_id === 55 ? (
          // Client 55 Script (KreditBee)
          hasSettlementAmount ? (
            // KreditBee - Settlement (Amount > 0)
            <div>
              <p className='mt-3'>
                Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
              </p>
              <p>
                Aapne apna <strong>{client_name}</strong> loan account, jo <strong>{loan_account_no}</strong> pe end hota hai, default kiya hai — kya ye sahi hai?
              </p>
              <p>
                <strong>{client_name}</strong> ne ye case hume legal proceedings start karne ke liye assign kiya hai. <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID par legal notice bhi bheja ja chuka hai.
              </p>
              <p>
                Saath hi, aapke khilaaf conciliation hearing schedule ki gayi thi, jiska current status <strong>{conciliation_status}</strong> show ho raha hai.
              </p>
              <p>
                Continuous non-payment ki wajah se lender ne hume legal action proceed karne ke instructions diye hain, jisme Civil Case, Criminal Case aur Police Complaint file ki ja sakti hai, as per law.
              </p>
              <p>
                Lekin legal action se pehle, aapko ek final opportunity di ja rahi hai is matter ko resolve karne ke liye.
              </p>
              <p>
                As on date, aapka total outstanding <strong>₹{pos}</strong> hai. Iske against, lender <strong>₹{pre_approved_settlement_amount}</strong> ke One Time Settlement / Waiver option पर account close karne ko tayaar hai, subject to immediate confirmation aur payment.
              </p>
              <p>
                Agar aap agree karte hain, to isi call par confirm karein. Agar aap cooperate nahi karte, to legal action as per instructions bina kisi further notice ke initiate kiya jayega.
              </p>
            </div>
          ) : (
            // KreditBee - No Settlement (Amount <= 0)
            language === 'english' ? (
              <div>
                <p className='mt-3'>
                  Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
                </p>
                <p>
                  You have defaulted on your <strong>{client_name}</strong> loan account ending <strong>{loan_account_no}</strong>. Is that correct?
                </p>
                <p>
                  This case has been assigned to us by <strong>{client_name}</strong> for initiating legal proceedings. A legal notice was already sent to your registered email ID on <strong>{formatDate(notice_date)}</strong>.
                </p>
                <p>
                  Please note that a conciliation hearing was also scheduled against you, and as per records, the current status shows <strong>{conciliation_status}</strong>.
                </p>
                <p>
                  Due to continuous non-payment, the lender has instructed us to proceed with legal action, which may include civil proceedings, criminal proceedings, and filing of a police complaint, as per applicable law.
                </p>
                <p>
                  As on date, your total overdue amount is <strong>₹{pos}</strong>, which is fully payable. Please note that no settlement or waiver option is available in this case.
                </p>
                <p>
                  You are required to clear the entire overdue amount immediately to avoid further legal consequences.
                </p>
                <p>
                  In case of non-payment, we will proceed with legal action as instructed, without any further notice.
                </p>
              </div>
            ) : (
              <div>
                <p className='mt-3'>
                  Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
                </p>
                <p>
                  Aapne apna <strong>{client_name}</strong> loan account, jo <strong>{loan_account_no}</strong> pe end hota hai, default kiya hai — kya ye sahi hai?
                </p>
                <p>
                  <strong>{client_name}</strong> ne ye case hume legal proceedings start karne ke liye assign kiya hai. <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID par legal notice bhi bheja ja chuka hai.
                </p>
                <p>
                  Saath hi, aapke khilaaf conciliation hearing schedule ki gayi thi, jiska current status <strong>{conciliation_status}</strong> show ho raha hai.
                </p>
                <p>
                  Continuous non-payment ki wajah se lender ne hume legal action ke instructions diye hain, jisme Civil Case, Criminal Case aur Police Complaint file ki ja sakti hai, as per law.
                </p>
                <p>
                  As on date, aapka total overdue amount <strong>₹{pos}</strong> hai, jo poori tarah se payable hai. Is case mein koi settlement ya waiver option available nahi hai.
                </p>
                <p>
                  Aapse expect kiya ja raha hai ki aap immediately poora overdue amount clear karein, taaki legal action avoid ho sake.
                </p>
                <p>
                  Agar payment nahi hota hai, to lender ke instructions ke according legal action bina kisi aur notice ke initiate kiya jayega.
                </p>
              </div>
            )
          )
        ) : (
          // Default Script (Client 83 / others)
          language === 'english' ? (
            <div>
              <p className='mt-3'>
                Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
              </p>

              <p>
                You have defaulted on the <strong>Credit Card</strong> account ending <strong>{loan_account_no}</strong>, issued by <strong>{client_name}</strong>. Is that correct?
              </p>

              <p>
                We have been assigned this case by <strong>{client_name}</strong> to initiate legal proceedings. A legal notice has already been sent to your registered email ID on <strong>{formatDate(notice_date)}</strong>.
              </p>

              <p>
                Due to continuous non-payment, the Bank has instructed us to proceed with legal action, which may include civil proceedings, criminal proceedings, or a police complaint, as per law.
              </p>

              <p>
                However, before proceeding legally, the Bank is offering you a One Time Settlement. Your total outstanding is <strong>₹{pos}</strong>
                {hasSettlementAmount ? (
                  <span>, which can be settled for <strong>₹{pre_approved_settlement_amount}</strong></span>
                ) : (
                  <span></span>
                )}, subject to immediate confirmation aur payment.
              </p>

              <p>
                If you are agreeable to this One Time Settlement, please confirm during this call. If not, we will proceed with legal action as instructed by the Bank.
              </p>
            </div>
          ) : (
            <div>
              <p className='mt-3'>
                Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
              </p>

              <p>
                Aapka <strong>{client_name}</strong> ka <strong>Credit Card</strong> account <strong>{loan_account_no}</strong> pe end hota hai aur system ke according aapka payment default mein hai — kya ye sahi hai?
              </p>

              <p>
                Ye case hume legal proceedings start karne ke liye assign kiya gaya hai. <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID par legal notice bheja ja chuka hai.
              </p>

              <p>
                Legal action se pehle, Bank aapko One Time Settlement ka final option de raha hai. Aapka total outstanding <strong>₹{pos}</strong> hai
                {hasSettlementAmount ? (
                  <span>, jo <strong>₹{pre_approved_settlement_amount}</strong> mein settle ho sakta hai</span>
                ) : (
                  <span></span>
                )}, subject to immediate confirmation aur payment.
              </p>

              <p>
                Agar aap agree karte hain, isi call par confirm karein. Agar nahi, to Bank ke instructions ke according legal action proceed kiya jayega.
              </p>
            </div>
          )
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between w-100">
        <Button
          variant="primary"
          size="md"
          onClick={() => setLanguage(language === 'english' ? 'hindi' : 'english')}
          disabled={client_id === 55 && hasSettlementAmount} // Settlement script is Hinglish only
        >
          {language === 'english' ? 'Switch to Hindi' : 'Switch to English'}
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default CallingScriptModal;